module.exports = __webpack_public_path__ + "static/media/life_co.d09bb2c1.png";